export default "__VITE_ASSET__gnQ5UxPn__"